export const KEPT_COPY_MESSAGE = "Another source captured this same conversation, and Origin shows that copy instead of a duplicate.";

export default function KeptCopyNotice({ onOpen }) {
    return (
        <div>
            <p className="m-0">{KEPT_COPY_MESSAGE}</p>
            <button
                type="button"
                onClick={onOpen}
                className="mt-[10px] cursor-pointer rounded-[2px] border border-[color:var(--line)] px-[8px] py-[3px] text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)] hover:border-[color:var(--ink)] hover:text-[color:var(--ink)] focus-visible:outline-2 focus-visible:outline-offset-2"
            >
                Open the copy Origin shows
            </button>
        </div>
    );
}
